import {Linktype} from "../../types/linktype";

export const igemreportstudylink: Linktype[] = [
    {
        title: "iGEM Team Munich- Interlaboratory Study",
        link: "https://static.igem.wiki/teams/4574/wiki/docs/igem-munich-interlab-2023-study.pdf",
        tag: "",
        author: "Munich 2023",
    },
    {
        title: "iGEM Human Practices Data Collection and Analysis Project",
        link: "https://static.igem.wiki/teams/5607/supplementary/hp-data-collection-summary.pdf",
        tag: "hp",
        author: "Jiangnan-China 2025"
    },
    {
        title: "Perspectives on Synthetic Biology: Public Awareness & Trust",
        link: "https://static.igem.wiki/teams/5916/education/public/perspective-analysis.pdf",
        tag: "hp",
        author: "Imperial 2025"
    },
]


/*
 {
        title: "",
        link: "",
        tag: "",
        author: ""
    }
 */